import { render, staticRenderFns } from "./FacilityDepartments.html?vue&type=template&id=713589ef&external"
import script from "./FacilityDepartments.js?vue&type=script&lang=js&external"
export * from "./FacilityDepartments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports